import { Navigate, Route, Routes } from "react-router-dom";
import CambiarClaveRecuperacionContainer from "../components/login/CambiarClaveRecuperacionContainer";
import LoginContainer from "../components/login/LoginContainer";
import RecuperarClaveContainer from "../components/login/RecuperarClaveContainer";

const PublicRoutes = () => {
  return (
    <Routes>
      <Route key="login" exact path="/" element={<LoginContainer />} />
      <Route key="recuperarClave" exact path="/recuperar-clave" element={<RecuperarClaveContainer />} />
      <Route key="cambiarClaveRecuperacion" exact path="/cambiar-clave-recuperacion" element={<CambiarClaveRecuperacionContainer />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export default PublicRoutes;
